<template>
  <header class="flex flex-col bg-neutral-100 px-3 min-h-screen">
    <form class="flex-grow flex flex-col items-center justify-center" autocomplete="off">
      <img src="img/logo.svg" class="max-w-full my-8" alt="NsLookup logo" width="337" height="57" />
      <DomainSearch autofocus emphasize @submitted="redirectTo" :button-text="searchButtonText" class="h-12 max-w-full w-[500px]" />
      <p class="mt-8 mb-8 sm:mb-20 text-center max-w-full w-[500px] text-neutral-800">
        <slot name="search-explanation" />
        <RedirectPizzaBanner v-if="showRedirectPizzaAds()" class="mt-20 mx-auto sm:hidden" />
      </p>
      <AdUnit class="mx-auto" :config="SearchPageAdUnit" />
    </form>
    <RedirectPizzaBanner v-if="showRedirectPizzaAds()" class="mb-6 mt-8 mx-auto hidden sm:flex" />
    <SponsorshipBanner v-else class="mb-6 mt-8 mx-auto" />
  </header>
  <ContentPage :domain-search-to-url="domainSearchToUrl" :search-button-text="searchButtonText">
    <template #content>
      <slot name="content" />
    </template>
  </ContentPage>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { useRouter } from 'vue-router';
import DomainSearch from '@/components/DomainSearch.vue';
import SponsorshipBanner from '@/components/layout/SponsorshipBanner.vue';
import { SearchPageAdUnit } from '@/common/adSlots';
import AdUnit from '@/components/ads/AdUnit.vue';
import ContentPage from '@/components/layout/ContentPage.vue';
import { showRedirectPizzaAds } from '@/common/dateTime';
import RedirectPizzaBanner from '@/components/layout/RedirectPizzaBanner.vue';

const props = defineProps({
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: (encodedDomain: string) => `/domains/${encodedDomain}/dns-records/`,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
});

const router = useRouter();

function redirectTo(domain: string): void {
  router.push(props.domainSearchToUrl(domain));
}
</script>
